import {Component} from '@angular/core';
import {WidgetInputDirective} from '../../directives/widget-input.directive';

@Component({
  selector: 'pt-widget-risk-assessment',
  template: `
    <div
      class='widget-border'
      data-testid="widget-risk-assessment"
      id='widget_{{initializationWidget.internalId}}'
      [ngSwitch]='initializationWidget?.version'>

      <ng-container *ngSwitchCase='0'>
        <pt-wra-v0
          [lockAcquired]='lockAcquired'
          [initializationWidget]='initializationWidget'
          [status]='status'>
        </pt-wra-v0>
      </ng-container>


      <pt-widget-version-missing
        *ngSwitchDefault
        [type]='initializationWidget?.type'
        [label]='initializationWidget?.label'
        [version]='initializationWidget?.version'>
      </pt-widget-version-missing>

    </div>
  `
})
export class WidgetRiskAssessmentComponent extends WidgetInputDirective {
}
